import { render, staticRenderFns } from "./InfoAndAdvice.vue?vue&type=template&id=6de13949&scoped=true&"
import script from "./InfoAndAdvice.vue?vue&type=script&lang=js&"
export * from "./InfoAndAdvice.vue?vue&type=script&lang=js&"
import style0 from "./InfoAndAdvice.vue?vue&type=style&index=0&id=6de13949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de13949",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
